import { z } from 'zod';

import { isValidUrl } from 'src/app/shared/components/endorsements';

export const STATEMENT_MAX_LENGTH = 1000;
export const NAME_MAX_LENGTH = 50;
export const TITLE_MAX_LENGTH = 100;

export const endorsementFormSchema = z.object({
	name: z
		.string()
		.trim()
		.min(1, 'This is a required field')
		.max(NAME_MAX_LENGTH, `Maximum ${NAME_MAX_LENGTH} characters allowed`),
	title: z
		.string()
		.trim()
		.min(1, 'This is a required field')
		.max(TITLE_MAX_LENGTH, `Maximum ${TITLE_MAX_LENGTH} characters allowed`),
	statement: z
		.string()
		.trim()
		.max(STATEMENT_MAX_LENGTH, `Maximum ${STATEMENT_MAX_LENGTH} characters allowed`)
		.optional()
		.or(z.literal('')),
	photoUrl: z.string().trim().min(1, 'This is a required field'),
	url: z.string().trim().min(1, 'This is a required field').refine(isValidUrl, 'Please enter a valid URL'),
});

export type EndorsementFormSchema = z.infer<typeof endorsementFormSchema>;
